<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
  <div class="vx-row">
    <!-- Address Col -->
    <div class="vx-col w-full md:w-1/2">
      <!-- Col Header -->
      <div class="flex items-end md:mt-0 mt-base">
        <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
        <span class="leading-none font-medium">Exam Information</span>
      </div>
      <!-- Col Content -->
      <div>
        <vs-input class="w-full mt-4" label="Exam 이름" v-model="data_local.test_name" />
        <!-- <vs-input class="w-full mt-4" label="출 제 원" v-model="data_local.institute" />
        <vs-input class="w-full mt-4" label="버전 정보" v-model="data_local.exam_version" /> -->
        <!-- <vs-input class="w-full mt-4" label="시험이름" v-model="data_local.institute" name="출제원" /> -->
        <div class="mt-4">
          <label class="text-sm">시험 출제 날짜</label>
          <flat-pickr class="w-full" v-model="data_local.release_time" />
        </div>
      </div>
    </div>
    <div class="vx-col w-full md:w-1/2">
      <!-- Col Content -->
      <div>
        <div class="flex items-end md:mt-0 mt-base">
          <feather-icon icon="FoloderIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Grade Information</span>
        </div>
        <!-- DOB -->
        <!-- <div class="mt-4">
          <label class="text-sm">시험 시작 날짜</label>
          <flat-pickr class="w-full" v-model="data_local.start_time" placeholder="시작일" @on-change="onFromChange" />
        </div>
        <div class="mt-4">
          <label class="text-sm">시험 종료 날짜</label>
          <flat-pickr class="w-full"  v-model="data_local.end_time" placeholder="종료일" @on-change="onToChange" />
        </div> -->

        <!-- Gender -->
        <div class="mt-4">
          <label class="text-sm">학년 정보</label>
          <div class="mt-2">
            <vs-radio v-model="data_local.grade_id" vs-value="10" class="mr-4">1학년</vs-radio>
            <!-- <vs-radio v-model="data_local.info" vs-value="middle" class="mr-4">중학교</vs-radio> -->
            <vs-radio v-model="data_local.grade_id" vs-value="11" class="mr-4">2학년</vs-radio>
            <vs-radio v-model="data_local.grade_id" vs-value="12" class="mr-4">3학년</vs-radio>
            <!-- <vs-radio v-model="data_local.info" vs-value="civil" class="mr-4">공무원</vs-radio> -->
            <!-- <vs-radio v-model="data_local.gender" vs-value="other">Other</vs-radio> -->
          </div>
        </div>

        <!-- <div class="mt-6" v-if="data_local.info == 'middle'">
          <label>학년</label>
          <div class="flex flex-wrap mt-1">
            <vs-radio v-model="data_local.grade" vs-value="1" class="mr-4">1학년</vs-radio>
            <vs-radio v-model="data_local.grade" vs-value="2" class="mr-4">2학년</vs-radio>
            <vs-radio v-model="data_local.grade" vs-value="3" class="mr-4">3학년</vs-radio>
          </div>
        </div> -->

        <!-- <div class="mt-6" v-if="data_local.info == 'high'">
          <label>학년</label>
          <div class="flex flex-wrap mt-1">
            <vs-radio v-model="data_local.grade" vs-value="10" class="mr-4">1학년</vs-radio>
            <vs-radio v-model="data_local.grade" vs-value="11" class="mr-4">2학년</vs-radio>
          </div>
        </div> -->

        <!-- <div class="mt-6" v-if="data_local.info == 'civil' ">
          <label>학년</label>
          <div class="flex flex-wrap mt-1">
            <vs-radio v-model="data_local.grade" vs-value="9" class="mr-4">9급</vs-radio>
            <vs-radio v-model="data_local.grade" vs-value="7" class="mr-4">7급</vs-radio>
            <vs-radio v-model="data_local.grade" vs-value="5" class="mr-4">5급</vs-radio>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Save & Reset Button -->
  <div class="vx-row" v-if="data_local.id == 0">
    <div class="vx-col w-full">
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="save">저장</vs-button>
      </div>
    </div>
  </div>
  <div class="vx-row" v-if="data_local.id != 0">
    <div class="vx-col w-full">
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="update">수정</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="move">다음</vs-button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      data_local: '',
      langOptions: [{
          label: "English",
          value: "english"
        },
        {
          label: "Spanish",
          value: "spanish"
        },
        {
          label: "French",
          value: "french"
        },
        {
          label: "Russian",
          value: "russian"
        },
        {
          label: "German",
          value: "german"
        },
        {
          label: "Arabic",
          value: "arabic"
        },
        {
          label: "Sanskrit",
          value: "sanskrit"
        },
      ],
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
    }
  },
  watch: {
    'data_local.grade_id'(e) {
      if(e == '10') this.data_local.info = 'high' , this.data_local.grade = 1
      if(e == '11') this.data_local.info = 'high' , this.data_local.grade = 2
      if(e == '12') this.data_local.info = 'sat' , this.data_local.grade = 3
    }
  },
  computed: {},
  methods: {
    save() {
      this.$store.commit('etest/ACTIVE_EXAML', this.data_local)

      if (this.data_local.release_time == null || this.data_local.test_name == '') {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '모든 항목을 입력해 주세요 :)'
        })
        return
      }

      this.$store.dispatch('etest/createEtestExam', this.data_local)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: this.data_local.test_name + '을 생성하였습니다.'
          })
          this.$emit('save')
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    move() {
      this.$emit('save')
    },
    update() {
      this.$store.dispatch('etest/updateEtestExam', this.data_local)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: this.data_local.test_name + '을 수정 하였습니다.'
          })
          this.$emit('save')
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr)
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
    },
  },
  created() {
    this.data_local = JSON.parse(JSON.stringify(this.$store.state.etest.activeExam))
    // console.log(this.data_local)
    this.configTodateTimePicker.maxDate = this.data_local.end_time
    this.configTodateTimePicker.minDate = this.data_local.start_time
  }
}
</script>
